import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BerthValidatorsModule } from '@shared/validators/berth/berth-validators.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderModule } from 'ngx-order-pipe';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormWidgetBerthOnlyComponent } from '@bcm-work-flows/@form-widgets/berth-only/form-widget-berth-only.component';
import { BcmPipesModule } from '@modules/bcm/@shared/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
    declarations: [FormWidgetBerthOnlyComponent],
    imports: [
        FuseSharedModule,
        SharedModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        BerthValidatorsModule,
        DirectivesModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        OrderModule,
        MatButtonToggleModule,
        DateTimeInputModule,
        BcmPipesModule,
        MatTooltipModule
    ],
    exports: [FormWidgetBerthOnlyComponent]
})
export class FormWidgetBerthOnlyModule {

}
